import { createContext, useContext } from 'react';

export interface CanvasAssetAdapters {
  /** 上传图片并返回可持久化 URL（页面背景、素材等） */
  uploadImage?: (file: File) => Promise<string>;
}

const CanvasAssetContext = createContext<CanvasAssetAdapters | null>(null);

export function CanvasAssetProvider({
  adapters,
  children,
}: {
  adapters?: CanvasAssetAdapters;
  children: React.ReactNode;
}) {
  return (
    <CanvasAssetContext.Provider value={adapters ?? null}>
      {children}
    </CanvasAssetContext.Provider>
  );
}

export function useCanvasAssetAdapters(): CanvasAssetAdapters {
  return useContext(CanvasAssetContext) ?? {};
}
